import React from "react"

import { StoreProvider } from "./StoreContext"
import { CalendrierProvider } from "./CalendrierContext";
import { Toaster } from "react-hot-toast";

const CombinedProvider = ({ element }) => {
  return (
    <CalendrierProvider>
      <StoreProvider>
        {element}
        <Toaster position="top-right" />
      </StoreProvider>
    </CalendrierProvider>
  )
}

export default CombinedProvider
